import { Button, Col, Row } from 'antd';
import React, { useEffect } from 'react';
import { LiaBackspaceSolid } from "react-icons/lia";
import Calculator from '../utils/Calculator';
import usePosOrderAPI from '../apis/posOrderAPI';
import EventEmitter from '../../utils/eventEmitter';
import { errorModal } from '../modals/ModalMessages';





const CalculatorButton = ({ disabled, carts, setCarts, tax }) => {
  const { updateSessionOrder } = usePosOrderAPI();
  const calculator = new Calculator(carts, setCarts, updateSessionOrder, tax);

  const onClickPrice = () => { };
  const onClickQty = () => { };
  const onClickDisc = () => { };
  const onClickPluMinus = () => { };
  const onClickDot = () => { };
  
  const onClickRemove = () => {
    calculator.delete();
  };

 const add = async (number) => {
    try {
      console.log(carts, carts.length)
      if (carts.length <= 0) {
        errorModal('CART EMPTY', <p>Please, add products to cart and try again</p>);
        return;
      }
      let items_ = [...carts];
      let found = items_.findIndex(cart => cart.select === true);
      if (found >= 0) {
        // console.log(typeof(items_[found].quantity) === 'number');
        let quantity = items_[found].quantity + number;
        
        // checks quantity is string
        if (typeof(quantity) === 'string') {
          let quantity_ = quantity.split('.');

          if (quantity_.length === 2) {
            let decimalQuantity = quantity_[1];
            if (decimalQuantity.length > 3) return;
            if (decimalQuantity.length === 3) {
              let decimalQuantity_ = parseFloat(decimalQuantity * 1);
              quantity_[1] = decimalQuantity_;
              let newQuantity = quantity_.join('.');
              items_[found].tax *= (newQuantity * 1).toFixed(2);
              items_[found].quantity = (newQuantity * 1).toFixed(2);
              let subtotal = (items_[found].quantity) * (items_[found].sales_price*1);
              items_[found].subtotal = subtotal;
              setCarts({event: 'UPDATE_QUANTITY', items: items_});
              return;
            };
          }
          
          let product = items_[found];
          items_[found].quantity = quantity;
          if (items_[found].tax_amount*1 >= 0 && items_[found].tax_id) {
            let subtotal = items_[found].quantity * items_[found].sales_price;
            switch (product.tax_computation) {
              case 'percent_of_price':
                items_[found]['tax'] = (parseFloat(product.tax_amount*1 / 100) * subtotal);
                // setTax(prev => prev + taxEntryObj['amount']);
                break;
              case 'percent_of_price_included':
                items_[found]['tax'] = (parseFloat(subtotal / 1 - (product.tax_amount*1 / 100))).toFixed(2) * 1;
                // setTax(prev => prev + taxEntryObj['amount']);
                break;
              case 'fixed':
                items_[found]['tax'] = (parseFloat(subtotal + product.tax_amount*1 / 100 )).toFixed(2) * 1;
                // setTax(prev => prev + taxEntryObj['amount']);
                break;
            };
          }else {
            items_[found].tax = 0;
          }
          let subtotal = (items_[found].quantity) * (items_[found].sales_price*1);
          items_[found].subtotal = subtotal;
          setCarts({event: 'UPDATE_QUANTITY', items: items_});
        }else{
          if (typeof(quantity) === 'number') {
            let subtotal = (items_[found].quantity) * (items_[found].sales_price*1);
              items_[found].subtotal = subtotal;
            setCarts({event: 'UPDATE_QUANTITY', items: items_});
          }
        }
      };
    }catch (err) {
      console.log(err);
    }
  }
  const handleKeyboardInput = (event) => {
    const key = event.key;
    
    // Check if the key is a number (0-9) or decimal point (.)
    if (event.ctrlKey || event.key === 'Control' || event.key === 'Fn') {
      // event.preventDefault(); // Prevent default behavior of these keys
      console.log("Ctrl or Fn key pressed, action prevented.");
    }else {
      if (/[0-9]/.test(key)) {

        add(key);
        console.log(key)
      }
        // Check for Enter key to trigger calculation
      else if (key === "Enter") {
        // handleOk();
        console.log('enter pressed');
      }
      // Check for backspace key to clear the last character (delete)
      else if (key === "Backspace") {
        calculator.delete();

        console.log('backspace pressed');
      }
      // Check for Escape key to clear the display
      else if (key === "Escape") {
        // resetPasscode();
          console.log('esc pressed');
      }
    }
  };
  
  // useEffect (() => {
      // let productSearch = window.document.getElementById('product-search');
      // let customerSearch = window.document.getElementById('customer-search');
  
        
      // document.addEventListener('keydown', handleKeyboardInput);
  
  
      // productSearch?.addEventListener('focus', () => {
      //   // Disable global listener (if input2 is focused)
      //   document.removeEventListener('keydown', handleKeyboardInput);
    
      //   // Add focused key listener to input2
      //   productSearch?.addEventListener('keydown', () => {});
      // });
  
      // productSearch?.addEventListener('blur', () => {
      //   // Remove focused listener from input2 (when it loses focus)
      //   productSearch?.removeEventListener('keydown', () => {});
    
      //   // Re-enable the global listener
      //   document.addEventListener('keydown', handleKeyboardInput);
      // });
  
  
      // customerSearch?.addEventListener('focus', () => {
      //   // Disable global listener (if input2 is focused)
      //   document.removeEventListener('keydown', handleKeyboardInput);
    
      //   // Add focused key listener to input2
      //   customerSearch?.addEventListener('keydown', () => {});
      // });
  
      // customerSearch?.addEventListener('blur', () => {
      //   // Remove focused listener from input2 (when it loses focus)
      //   customerSearch?.removeEventListener('keydown', () => {});
    
      //   // Re-enable the global listener
      //   document.addEventListener('keydown', handleKeyboardInput);
      // });
  
    // },[])

  return (
    <Row className='h-full'>
      <Col md={{span: 6}}>
        <div className='border w-full h-1/4'><Button disabled={disabled} type='text' className='font-semibold w-full h-full rounded-none' onClick={()=> calculator.add('1')}>1</Button></div>
        <div className='border w-full h-1/4'><Button disabled={disabled} type='text' className='font-semibold w-full h-full rounded-none' onClick={()=> calculator.add('4')}>4</Button></div>
        <div className='border w-full h-1/4'><Button disabled={disabled} type='text' className='font-semibold w-full h-full rounded-none' onClick={()=> calculator.add('7')}>7</Button></div>
        <div className='border w-full h-1/4'><Button disabled={disabled} type='text' className='font-semibold w-full h-full rounded-none' onClick={onClickPluMinus}>+/-</Button></div>
      </Col>
      <Col md={{span: 6}}>
        <div className='border w-full h-1/4'><Button disabled={disabled} type='text' className='font-semibold w-full h-full rounded-none' onClick={()=> calculator.add('2')}>2</Button></div>
        <div className='border w-full h-1/4'><Button disabled={disabled} type='text' className='font-semibold w-full h-full rounded-none' onClick={()=> calculator.add('5')}>5</Button></div>
        <div className='border w-full h-1/4'><Button disabled={disabled} type='text' className='font-semibold w-full h-full rounded-none' onClick={()=> calculator.add('8')}>8</Button></div>
        <div className='border w-full h-1/4'><Button disabled={disabled} type='text' className='font-semibold w-full h-full rounded-none' onClick={()=> calculator.add('0')}>0</Button></div>
      </Col>
      <Col md={{span: 6}}>
        <div className='border w-full h-1/4'><Button disabled={disabled} type='text' className='font-semibold w-full h-full rounded-none' onClick={()=> calculator.add('3')}>3</Button></div>
        <div className='border w-full h-1/4'><Button disabled={disabled} type='text' className='font-semibold w-full h-full rounded-none' onClick={()=> calculator.add('6')}>6</Button></div>
        <div className='border w-full h-1/4'><Button disabled={disabled} type='text' className='font-semibold w-full h-full rounded-none' onClick={()=> calculator.add('9')}>9</Button></div>
        <div className='border w-full h-1/4'><Button disabled={disabled} type='text' className='font-semibold w-full h-full rounded-none' onClick={()=> calculator.add('.')}>.</Button></div>
      </Col>
      <Col sm={{span: 6}}>
        <div className='w-full h-1/4'><Button disabled={disabled} type='text' className='font-semibold w-full h-full rounded-none selected text-white' onClick={onClickQty}>Qty</Button></div>
        <div className='border w-full h-1/4'><Button disabled={disabled} type='text' className='font-semibold w-full h-full rounded-none' onClick={onClickDisc}>%Disc</Button></div>
        <div className='border w-full h-1/4'><Button disabled={disabled} type='text' className='font-semibold w-full h-full rounded-none' onClick={onClickPrice}>Price</Button></div>
        <div className='border w-full h-1/4'><Button disabled={disabled} type='text' className='font-semibold w-full h-full rounded-none text-center' onClick={onClickRemove}><LiaBackspaceSolid size={'1.7rem'} width={'100%'}/></Button></div>
      </Col>
    </Row>
  )
}

export default CalculatorButton;